import { Placeholder } from "react-bootstrap";
import ProviderService from "../../../../../../services/ProviderService";
import ClinicService from "../../../../../../services/ClinicService";
import {
  formatDate,
  isSet,
  optionsToKeyValuePairs,
  locations,
  getOrganizationId,
} from "../../../../../../utils/commonUtils";
import { OnTabKeyPress } from "../../../../../../utils/cssUtils";
import { computationRules1 } from "./DrugScreenCollection";
const HEARING_AID_NA_DISABLE_RULE = [
  { rule: [{ field: "check_hearing_aid_used", value: "N/A", operator: "===" }], action: "DISABLE" },
];

// Canadian province codes to filter out (only show US states)
const canadianProvinces = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT",
];

// State options (US states only)
const stateOptions = [
  { label: "-Select State-", value: "" },
  ...Object.keys(locations)
    .filter((key) => !canadianProvinces.includes(key))
    .map((key) => ({
      label: key,
      value: key,
    })),
];

export const NonDOTExamHearingAudio1 = (props, type = "Others") => {
  const physicalExamination = [
    { label: "General", name: "physical_examination_general" },
    { label: "Skin", name: "physical_examination_skin" },
    { label: "Eyes", name: "physical_examination_eyes" },
    { label: "Ears", name: "physical_examination_ears" },
    { label: "Mouth / throat", name: "physical_examination_mouth_throat" },
    { label: "Cardiovascular", name: "physical_examination_cardiovascular" },
    { label: "Lungs / chest", name: "physical_examination_lungs_chest" },
    { label: "Abdomen", name: "physical_examination_abdomen" },
    {
      label: "Genito urinary sys / hernias",
      name: "physical_examination_genito_urinary",
    },
    { label: "Back / Spine", name: "physical_examination_back_spine" },
    {
      label: "Extremities / joints",
      name: "physical_examination_extremities_joints",
    },
    {
      label: "Neurological sys / reflexes",
      name: "physical_examination_neurological_sys_reflexes",
    },
    { label: "Gait", name: "physical_examination_gait" },
    { label: "Vascular system", name: "physical_examination_vascular_system" },
  ];

  let patientHealthInformation = [];
  if (type == "ProviderExam") {
    patientHealthInformation = [
      {
        label: "1. Head/brain injuries (e.g., concussion, seizures)",
        name: "head_brain_injuries",
      },
      { label: "2. Seizures, epilepsy", name: "seizures_epilepsy" },
      {
        label: "3. Eye problems (except glasses or contacts)",
        name: "eye_problems",
      },
      { label: "4. Ear and/or hearing problems", name: "ear_hearing_problems" },
      {
        label: "5. Heart disease, heart attack, bypass, or other",
        name: "heart_disease",
      },
      {
        label:
          "6. Pacemaker, stents, implantable devices, or other heart procedures",
        name: "pacemaker_stents_implantable_devices",
      },
      { label: "7. High blood pressure", name: "high_blood_pressure" },
      { label: "8. High cholesterol", name: "high_cholesterol" },
      {
        label:
          "9. Chronic (long-term) cough, shortness of breath, or other breathing problems",
        name: "chronic_breathing_problems",
      },
      { label: "10. Lung disease (e.g., asthma)", name: "lung_disease" },
      {
        label: "11. Kidney problems, kidney stones, or pain w/ urination",
        name: "kidney_problems",
      },
      {
        label: "12. Stomach, liver, or digestive problems",
        name: "digestive_problems",
      },
      {
        label: "13. Diabetes or blood sugar problems Insulin used",
        name: "diabetes_insulin",
      },
      {
        label: "14. Anxiety, depression, other mental problems",
        name: "mental_problems",
      },
      { label: "15. Fainting or passing out", name: "fainting_passing_out" },
      {
        label: "16. Dizziness, headaches, numbness, tingling",
        name: "dizziness_headaches",
      },
      { label: "17. Unexplained weight loss", name: "unexplained_weight_loss" },
      {
        label: "18. Stroke, mini-stroke (TIA), paralysis, or weakness",
        name: "stroke_paralysis_weakness",
      },
      {
        label:
          "19. Missing or limited use of arm, hand, finger, leg, foot, toe",
        name: "missing_limited_use_of_limbs",
      },
      { label: "20. Neck or back problems", name: "neck_back_problems" },
      {
        label: "21. Bone, muscle, joint, or nerve problems",
        name: "bone_muscle_joint_nerve_problems",
      },
      {
        label: "22. Blood clots or bleeding problems",
        name: "blood_clots_bleeding",
      },
      { label: "23. Cancer", name: "cancer" },
      {
        label: "24. Chronic (long-term) infection or other",
        name: "chronic_infection",
      },
      {
        label:
          "25. Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring",
        name: "sleep_disorders",
      },
      {
        label: "26. Have you ever had a sleep test (e.g., sleep apnea)?",
        name: "had_sleep_test",
      },
      {
        label: "27. Have you ever spent a night in the hospital?",
        name: "hospital_stay",
      },
      {
        label: "28. Have you ever had a broken bone?",
        name: "had_broken_bone",
      },
      {
        label: "29. Have you ever used or do you now use tobacco?",
        name: "tobacco_use",
      },
      { label: "30. Do you currently drink alcohol?", name: "alcohol_use" },
      {
        label: "31. Use of an illegal substance within the past 2 years",
        name: "illegal_substance_use",
      },
      {
        label: "32. Have you ever failed a drug test or been dependent?",
        name: "drug_test_failure",
      },
    ];
  } else {
    patientHealthInformation = [
      {
        label: "1. Head/brain injuries or illnesses (e.g., concussion)",
        name: "head_brain_injuries",
      },
      { label: "2. Seizures, epilepsy", name: "seizures_epilepsy" },
      {
        label: "3. Eye problems (except glasses or contacts)",
        name: "eye_problems",
      },
      { label: "4. Ear and/or hearing problems", name: "ear_hearing_problems" },
      {
        label:
          "5. Heart disease, heart attack, bypass, or other heart problems",
        name: "heart_disease",
      },
      {
        label:
          "6. Pacemaker, stents, implantable devices, or other heart procedures",
        name: "pacemaker_stents_implantable_devices",
      },
      { label: "7. High blood pressure", name: "high_blood_pressure" },
      { label: "8. High cholesterol", name: "high_cholesterol" },
      {
        label:
          "9. Chronic (long-term) cough, shortness of breath, or other breathing problems",
        name: "chronic_cough",
      },
      {
        label:
          "10. Kidney problems, kidney stones, or pain/problems with urination",
        name: "kidney_problems",
      },
      {
        label: "11. Stomach, liver, or digestive problems",
        name: "digestive_problems",
      },
      {
        label: "12. Diabetes or blood sugar problems Insulin used",
        name: "diabetes_insulin",
      },
      {
        label:
          "13. Anxiety, depression, nervousness, other mental health problems",
        name: "mental_problems",
      },
      { label: "14. Fainting or passing out", name: "fainting_passing_out" },
      {
        label: "15. Dizziness, headaches, numbness, tingling, or memory loss",
        name: "dizziness_headaches",
      },
      { label: "16. Unexplained weight loss", name: "unexplained_weight_loss" },
      {
        label: "17. Stroke, mini-stroke (TIA), paralysis, or weakness",
        name: "stroke_paralysis_weakness",
      },
      {
        label:
          "18. Missing or limited use of arm, hand, finger, leg, foot, toe",
        name: "missing_limited_use_of_limbs",
      },
      { label: "19. Neck or back problems", name: "neck_back_problems" },
      {
        label: "20. Bone, muscle, joint, or nerve problems",
        name: "bone_muscle_joint_nerve_problems",
      },
      {
        label: "21. Blood clots or bleeding problems",
        name: "blood_clots_bleeding",
      },
      { label: "22. Cancer", name: "cancer" },
      {
        label: "23. Chronic (long-term) infection or other chronic diseases",
        name: "chronic_infection",
      },
      {
        label:
          "24. Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring",
        name: "sleep_disorders",
      },
      {
        label: "25. Have you ever had a sleep test (e.g., sleep apnea)?",
        name: "had_sleep_test",
      },
      {
        label: "26. Have you ever spent a night in the hospital?",
        name: "hospital_stay",
      },
      {
        label: "27. Have you ever had a broken bone?",
        name: "had_broken_bone",
      },
      {
        label: "28. Have you ever used or do you now use tobacco?",
        name: "tobacco_use",
      },
      { label: "29. Do you currently drink alcohol?", name: "alcohol_use" },
      {
        label:
          "30. Have you used an illegal substance within the past two years?",
        name: "illegal_substance_use",
      },
      {
        label:
          "31. Have you ever failed a drug test or been dependent on an illegal substance?",
        name: "drug_test_failure",
      },
    ];
  }
  const setAllDefaultValues = {
    accompanied_by_waiver_exemption: 0,
    accompanied_by_spe_certificate: 0,
    driving_within_an_exempt_intracity_zone: 0,
    determination_pending: 0,
    return_to_medical_exam_office_for_follow_up: 0,
    medical_examination_report_amended: 0,
    incomplete_examination: 0,
  };

  const charts = [
    {
      type: "Grid",
      col: "col-md-3 px-0",
      className: 'non-dot-exam-scrollable',
      style: {
        position: "sticky",
        top: "0",
        zIndex: "1",
        height: "calc(100vh - 200px)",
        overflowY: "auto",
        overflowX: "hidden"
    },
      data: [
        {
          type: "PatientDetails",
          employeeDetails: props.employeeDetails,
          visitDetails: props.visitDetails,
        },
        {
          type: "CompanyDetails",
          companyDetails: props.companyDetails
      },
        {
          type: "ResultSummary",
          results: [
            {
              normalMsg: "Patient History",
              abnormalMsg: "Patient History",
              label: "Patient",
              data: [
                {
                  label: "Surgeries",
                  keyVal: "surgery_history",
                  type: "yesorno",
                },
                {
                  label: "Medications",
                  keyVal: "taking_medications",
                  type: "yesorno",
                },
                {
                  label: "Health History",
                  keyVal: patientHealthInformation.map((item) => item.name),
                  type: "ANY",
                },
              ],
            },
            {
              normalMsg: "Screening",
              abnormalMsg: "Screening",
              data: [
                { label: "Pulse", keyVal: "pulse_rate_result" },
                { label: "Blood Pressure", keyVal: "blood_pressure_result" },
                { label: "Vision", keyVal: "vission_result" },
                { label: "Hearing", keyVal: "hearing_result" },
                // { label: 'Urinalysis', keyVal: 'urinalysis_result' },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "Tab",
      col: "col-md-9",
      data: [
        {
          label: "History",
          id: "history",
          labelStyle: "padding: 0;",

          data: [
            {
              label: "Driver health Information",
              labelStyle: "fw-semibold",
              fields: [
                {
                  label:
                    "Have you ever had surgery? If “yes,” please list and explain below.",
                  type: "RadioGroup",
                  labelWrap: false,
                  name: "surgery_history",
                  col: "col-12 border-0 ",
                  id: "surgery_history",
                  options: [
                    {
                      label: "Yes",
                      value: "Yes",
                      labelStyle: { color: "red" },
                      inputStyle: {
                        backgroundColor: "red",
                        borderColor: "red",
                      },
                    },
                    { label: "No", value: "No" },
                    {
                      label: "Not Sure",
                      value: "Not Sure",
                      labelStyle: { color: "red" },
                      inputStyle: {
                        backgroundColor: "red",
                        borderColor: "red",
                      },
                    },
                  ],
                },
                {
                  label: "",
                  type: "TextArea",
                  col: "col-12 border-0",
                  disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "surgery_history",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "ENABLE",
                    },
                    {
                      rule: [
                        {
                          field: "surgery_history",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "REQUIRED",
                      errorMessage:
                        "Please provide an explanation for the surgery.",
                    },
                  ],
                  isLabel: false,
                  name: "surgery_explanation",
                  id: "surgery_explanation",
                  placeholder: "Add Comments",
                },
                {
                  label:
                    "Are you currently taking medications (prescription, over-the-counter, herbal remedies, diet supplements)? If “yes,” please describe below.",
                  type: "RadioGroup",
                  col: "col-12 border-0",
                  labelWrap: false,
                  name: "taking_medications",
                  id: "taking_medications",
                  options: [
                    {
                      label: "Yes",
                      value: "Yes",
                      labelStyle: { color: "red" },
                      inputStyle: {
                        backgroundColor: "red",
                        borderColor: "red",
                      },
                    },
                    { label: "No", value: "No" },
                    {
                      label: "Not Sure",
                      value: "Not Sure",
                      labelStyle: { color: "red" },
                      inputStyle: {
                        backgroundColor: "red",
                        borderColor: "red",
                      },
                    },
                  ],
                },
                {
                  label: "",
                  type: "TextArea",
                  col: "col-12 border-0",
                  isLabel: false,
                  disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "ENABLE",
                    },
                    {
                      rule: [
                        {
                          field: "taking_medications",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "REQUIRED",
                      errorMessage:
                        "Please provide an explanation for the medications.",
                    },
                  ],
                  name: "taking_medication_explanation",
                  id: "taking_medication_explanation",
                  placeholder: "Add Comments",
                },
              ],
            },
            {
              label: 'Do you have or have you ever had',
              hideHeader: true, // Single header: "History" + Yes/No in NewYesOrNoFields header only
              cardBodyClassName: 'p-0',              fields: [
                {
                  col: "col-12",
                  defaultBtnLabel: "Set all to No",
                  type: "NewYesOrNoFields",
                  label: "Do you have or have you ever had",
                  options: [
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                    { label: "Not Sure", value: "Not Sure" },
                  ],
                  defaultValues: patientHealthInformation.reduce((acc, itm) => {
                    acc[itm.name] = "No";
                    return acc;
                  }, {}),
                  failedValue: ["Yes", "Not Sure"],
                  list: patientHealthInformation,
                },
                {
                  label: "32.Other health condition(s) not described above ?",
                  type: "RadioGroup",
                  name: "other_conditions",
                  col: "col-12 border-0",
                  id: "other_conditions",
                  options: ["Yes", "No", "Not Sure"],
                },
                {
                  label: "",
                  type: "TextArea",
                  placeholder: "Add Comments",
                  col: "col-12 border-0",
                  isLabel: false,
                  disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "other_conditions",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "ENABLE",
                    },
                    {
                      rule: [
                        {
                          field: "other_conditions",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "REQUIRED",
                      errorMessage:
                        "Please describe the other health conditions.",
                    },
                  ],
                  name: "other_conditions_description",
                  id: "other_conditions_description",
                },
                {
                  label: `33.Did you answer 'yes' to any of questions 1-${
                    type === "ProviderExam" ? "32" : "25"
                  }? If so, please comment further on those health conditions below.`,
                  type: "RadioGroup",
                  name: "additional_comments",
                  id: "additional_comments",
                  labelWrap: false,
                  col: "col-12 border-0",
                  options: ["Yes", "No", "Not Sure"],
                },
                {
                  label: "",
                  type: "TextArea",
                  placeholder: "Add Comments",
                  col: "col-12 border-0",
                  isLabel: false,
                  disabled: true,
                  rules: [
                    {
                      rule: [
                        {
                          field: "additional_comments",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "ENABLE",
                    },
                    {
                      rule: [
                        {
                          field: "additional_comments",
                          value: "Yes",
                          operator: "===",
                        },
                      ],
                      action: "REQUIRED",
                      errorMessage: "Please provide additional comments.",
                    },
                  ],
                  name: "additional_comments_description",
                  id: "additional_comments_description",
                },
              ],
            },
            type === "ProviderExam"
              ? {
                  label: "CMV Driver",
                  labelStyle: "fw-semibold",
                  col: "col-12",
                  fields: [
                    {
                      label:
                        "I certify that the above information is accurate and complete. I understand that inaccurate, false or missing information may invalidate the examination.",
                      type: "Label",
                      col: "col-12 border-0  text-dark",
                    },
                    {
                      label: "Driver's Signature",
                      type: "NewSignature",
                      isLabel: false,
                      col: "col-md-6 col-12 border-0",
                      name: "driver_signature",
                      id: "driver_signature",
                    },
                    {
                      label: "Date",
                      type: "NewDate",
                      col: "col-md-6 col-12 border-0",
                      isLabel: false,
                      id: "signatured_date",
                      name: "signatured_date",
                    },
                  ],
                }
              : {
                  label: "Approval Signature & Date",
                  note: "I certify that the above information is accurate and complete.",
                  col: "col-12",
                  fields: [
                    {
                      label: "Employee Signature",
                      isLabel: false,
                      type: "NewSignature",
                      col: "col-md-6 col-12 border-0",
                      name: "employee_signature",
                      id: "employee_signature",
                    },
                    {
                      label: "Date",
                      type: "NewDate",
                      isLabel: false,
                      col: "col-md-6 col-12 border-0",
                      id: "signatured_date",
                      name: "signatured_date",
                    },
                  ],
                },
          ],
        },
        {
          label: "Screening",
          id: "screening",
          data: [
            {
              label: "Vitals Signs",
              fields: [
                {
                  label: "Blood Pressure Systolic (1st Reading)",
                  isLabel: false,
                  col: "col-6 border-0 ",
                  type: "NewNumber",
                  placeholder: "Systolic",
                  name: "sitting_systolic",
                  id: "sitting_systolic",
                  rangeMax: 139,
                  rangeMin: 90,
                  onKeyPress: (event) =>
                    OnTabKeyPress(event, "sitting_diastolic", ""),
                  Max: 3,
                },
                {
                  label: "Blood Pressure Systolic(2nd Reading)",
                  isLabel: false,
                  col: "col-6 border-0 ",
                  type: "NewNumber",
                  placeholder: "Systolic",
                  name: "second_reading_systolic",
                  id: "second_reading_systolic",
                  rangeMax: 139,
                  rangeMin: 90,
                  Max: 3,
                },
                {
                  label: "Blood Pressure Diastolic (1st Reading)",
                  isLabel: false,
                  col: "col-6 border-0 ",
                  type: "NewNumber",
                  placeholder: "Diastolic",
                  name: "sitting_diastolic",
                  id: "sitting_diastolic",
                  rangeMin: 60,
                  rangeMax: 89,
                  onKeyPress: (event) => OnTabKeyPress(event, "pulse_rate"),
                  Max: 3,
                },
                {
                  label: "Blood Pressure Diastolic(2nd Reading)",
                  isLabel: false,
                  col: "col-6 border-0 ",
                  type: "NewNumber",
                  placeholder: "Diastolic",
                  name: "second_reading_diastolic",
                  id: "second_reading_diastolic",
                  rangeMin: 60,
                  rangeMax: 89,
                  Max: 3,
                },
                {
                  label: "Pulse Rate",
                  isLabel: false,
                  col: "col-6 border-0 ",
                  type: "NewNumber",
                  placeholder: "Pulse Rate",
                  name: "pulse_rate",
                  rangeMin: 60,
                  rangeMax: 100,
                  id: "pulse_rate",
                  Max: 3,
                },
                {
                  label: "Pulse Rhythm Regular",
                  type: "RadioGroup",
                  col: "col-6 border-0 ",
                  name: "pulse_rhythm_regular",
                  id: "pulse_rhythm_regular",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                },
                {
                  label: "Height (Feet)",
                  placeholder: "Feet",
                  isLabel: false,
                  col: "col-6 border-0 ",
                  type: "NewNumber",
                  Max: 1,
                  name: "height_feet",
                  id: "height_feet",
                },
                {
                  label: "Inches",
                  isLabel: false,
                  placeholder: "Inches",
                  col: "col-6 border-0 ",
                  type: "NewDecimal",
                  name: "height_inches",
                  id: "height_inches",
                //   Max: 2,
                },
                {
                  label: "Weight (In Pounds)",
                  isLabel: false,
                  placeholder: "Pounds",
                  type: "NewNumber",
                  name: "weight_pounds",
                  id: "weight_pounds",
                  col: "col-6 border-0 ",
                  Max: 3,
                },
                {
                  label: "Neck Circumference (In)",
                  isLabel: false,
                  placeholder: "Circumference",
                  type: "NewDecimal",
                  name: "neck_circumference",
                  id: "neck_circumference",
                  col: "col-6 border-0 ",
                },
                {
                  label: "Oxygen Saturation (SpO2)",
                  isLabel: false,
                  placeholder: "SpO2",
                  type: "NewNumber",
                  name: "oxygen_saturation",
                  id: "oxygen_saturation",
                  col: "col-6 border-0 ",
                  Max: 3,
                },
              ],
            },
            {
              label: "Vision",
              fields: [
                {
                  label: "Is vision corrected or uncorrected?",
                  col: "col-12 border-0 ",
                  type: "RadioGroup",
                  name: "wearing_corrective_lenses",
                  id: "wearing_corrective_lenses",
                  options: [
                    { label: "Corrected", value: 1 },
                    { label: "Uncorrected", value: 0 },
                  ],
                },
                {
                  label: "VISION",
                  type: "Label",
                  col: "col-3  bg-light  text-vision-heading fw-bold", // Matches the "sh_emrmotiontd" header
                },
                {
                  label: "UNCORRECTED",
                  type: "Label",
                  col: "col-3  bg-light text-vision-heading fw-bold",
                },
                {
                  label: "CORRECTED",
                  type: "Label",
                  col: "col-3  bg-light  text-vision-heading fw-bold",
                },
                {
                  label: "Horizontal Field of Vision",
                  type: "Label",
                  col: "col-3  bg-light  text-vision-heading fw-bold",
                },
                // --- ROW 1: LEFT ---
                {
                  label: "Left eyes",
                  type: "Label",
                  col: "col-3 border-0 d-flex text-dark  align-items-center", // Vertically center the text
                },
                {
                  label: "",
                  isLabel: false,
                  type: 'VisionNumber',
                  name: "uncorrected_left_eye",
                  id: "uncorrected_left_eye",
                  col: "col-3 border-0",
                  placeholder: "Content",
                  isNumeric: true,
                  rangeMax: 40,
                  max: 2,
                  rules: [
                    {
                      rule: [
                        {
                          field: "wearing_corrective_lenses",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                  onKeyPress: (event) =>
                    OnTabKeyPress(event, "uncorrected_right_eye", ""),
                },
                {
                  label: "",
                  isLabel: false,
                  type: 'VisionNumber',
                  name: "corrected_left_eye",
                  id: "corrected_left_eye",
                  col: "col-3 border-0",
                  placeholder: "Content",
                  isNumeric: true,
                  rangeMax: 40,
                  max: 2,
                  rules: [
                    {
                      rule: [
                        {
                          field: "wearing_corrective_lenses",
                          value: 0,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                  onKeyPress: (event) =>
                    OnTabKeyPress(
                      event,
                      "corrected_right_eye",
                      "wearing_corrective_lenses"
                    ),
                },
                {
                  label: "",
                  isLabel: false,
                  type: "Number",
                  name: "horizontal_field_of_vision_left_eye",
                  id: "horizontal_field_of_vision_left_eye",
                  col: "col-3 border-0",
                  placeholder: "Degrees",
                  isNumeric: true,
                  rangeMin: 70,
                  rangeMax: 90,
                  max: 3,
                  // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'CLEAR'}],
                  onKeyPress: (event) =>
                    OnTabKeyPress(
                      event,
                      "horizontal_field_of_vision_right_eye",
                      "horizontal_field_of_vision_right_eye"
                    ),
                },

                // --- ROW 2: RIGHT ---
                {
                  label: "Right eyes",
                  type: "Label",
                  col: "col-3 border-0 text-dark d-flex align-items-center",
                },
                {
                  label: "",
                  isLabel: false,
                  type: 'VisionNumber',
                  name: "uncorrected_right_eye",
                  id: "uncorrected_right_eye",
                  col: "col-3 border-0",
                  placeholder: "Content",
                  isNumeric: true,
                  rangeMax: 40,
                  max: 2,
                  rules: [
                    {
                      rule: [
                        {
                          field: "wearing_corrective_lenses",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                  onKeyPress: (event) =>
                    OnTabKeyPress(
                      event,
                      "uncorrected_both_eyes",
                      "uncorrected_left_eye"
                    ),
                },
                {
                  label: "",
                  isLabel: false,
                  type: 'VisionNumber',
                  name: "corrected_right_eye",
                  id: "corrected_right_eye",
                  col: "col-3 border-0",
                  placeholder: "Content",
                  isNumeric: true,
                  rangeMax: 40,
                  max: 2,
                  rules: [
                    {
                      rule: [
                        {
                          field: "wearing_corrective_lenses",
                          value: 0,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                  onKeyPress: (event) =>
                    OnTabKeyPress(
                      event,
                      "corrected_both_eyes",
                      "corrected_left_eye"
                    ),
                },
                {
                  label: "",
                  isLabel: false,
                  type: "Number",
                  name: "horizontal_field_of_vision_right_eye",
                  id: "horizontal_field_of_vision_right_eye",
                  col: "col-3 border-0",
                  placeholder: "Degrees",
                  isNumeric: true,
                  rangeMin: 70,
                  rangeMax: 90,
                  max: 3, // DOT normal max

                  // rules:[{rule:[{field:'wearing_corrective_lenses',value:0,operator:'==='}],action:'CLEAR'}],
                  // onKeyPress: (event) => OnTabKeyPress(event, "corrected_both_eyes" || "horizontal_field_of_vision_left_eye", "corrected_right_eye"),
                },

                // --- ROW 3: BOTH ---
                {
                  label: "Both eyes",
                  type: "Label",
                  col: "col-3 border-0 text-dark d-flex align-items-center",
                },
                {
                  label: "",
                  isLabel: false,
                  type:'VisionNumber',
                  name: "uncorrected_both_eyes",
                  id: "uncorrected_both_eyes",
                  col: "col-3 border-0",
                  placeholder: "Content",
                  isNumeric: true,
                  rangeMax: 40,
                  max: 2,
                  rules: [
                    {
                      rule: [
                        {
                          field: "wearing_corrective_lenses",
                          value: 1,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                  onKeyPress: (event) =>
                    OnTabKeyPress(
                      event,
                      "horizontal_field_of_vision_left_eye",
                      "uncorrected_right_eye"
                    ),
                },
                {
                  label: "",
                  isLabel: false,
                  type: 'VisionNumber',
                  name: "corrected_both_eyes",
                  id: "corrected_both_eyes",
                  col: "col-3 border-0",
                  placeholder: "Content",
                  isNumeric: true,
                  rangeMax: 40,
                  max: 2,
                  rules: [
                    {
                      rule: [
                        {
                          field: "wearing_corrective_lenses",
                          value: 0,
                          operator: "===",
                        },
                      ],
                      action: "CLEAR",
                    },
                  ],
                  onKeyPress: (event) =>
                    OnTabKeyPress(
                      event,
                      "horizontal_field_of_vision_left_eye",
                      "uncorrected_both_eyes"
                    ),
                },
                {
                  label: "",
                  type: "Label",
                  col: "col-3 border-0",
                },
                
                // --- QUESTION 1: Traffic Signals ---
                {
                  label:
                    "Applicant can recognize and distinguish among traffic control signals and devices showing red, green, and amber colors",
                  type: "RadioGroup",
                  name: "applicant_recognize_traffic_control_signals",
                  labelWrap: false,
                  col: "col-12 border-0 mt-3",
                  id: "applicant_recognize_traffic_control_signals",
                  options: [
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                  ],
                  failedValue: ["No"],
                },

                // --- QUESTION 2: Monocular Vision ---
                {
                  label: "Monocular vision",
                  type: "RadioGroup",
                  name: "monocular_vision", // Fixed: duplicate name removed
                  col: "col-12 border-0",
                  id: "monocular_vision",
                  options: [
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                  ],
                  failedValue: ["Yes"],
                },

                // --- QUESTION 3: Referred ---
                {
                  label: "Referred to ophthalmologist or optometrist?",
                  type: "RadioGroup",
                  name: "referred_to_ophthalmologist",
                  col: "col-12 border-0",
                  id: "referred_to_ophthalmologist",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                  failedValue: [1],
                },

                // --- QUESTION 4: Received Documentation ---
                {
                  label:
                    "Received documentation from ophthalmologist or optometrist?",
                  type: "RadioGroup",
                  name: "received_documentation_from_ophthalmologist",
                  col: "col-12 border-0",
                  id: "received_documentation_from_ophthalmologist",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                  failedValue: [1],
                },
              ],
            },
            {
              label: "Hearing",
              fields: [
                {
                  label: "Check if hearing aid used for test",
                  col: "col-12 border-0 ",
                  type: "RadioGroup",
                  name: "check_hearing_aid_used",
                  id: "check_hearing_aid_used",
                  options: ["Right Ear", "Left Ear", "Neither","N/A"],
                  required: true,
                },
                {
                  label: "Whisper Test Results",
                  type: "Label",
                  col: "col-12 border-0 text-audio-heading font-weight-bold",
                },
                {
                  label: "Right Ear",
                  isLabel: false,
                  type: "NewNumber",
                  placeholder: "Right Ear",
                  col: "col-6 border-0 ",
                  rangeMin: 5,
                  Max: 2,
                  name: "whisper_test_results_right_ear",
                  id:'whisper_test_results_right_ear',
                  rules: HEARING_AID_NA_DISABLE_RULE,
                  // rules: [{ rule: [{ field: 'check_hearing_aid_used', value: 'Left Ear', operator: '===' }], action: 'CLEAR' }],
                },
                {
                  label: "Left Ear",
                  isLabel: false,
                  type: "NewNumber",
                  placeholder: "Left Ear",
                  col: "col-6 border-0 ",
                  rangeMin: 5,
                  Max: 2,
                  name: "whisper_test_results_left_ear",
                  id: "whisper_test_results_left_ear",
                  rules: HEARING_AID_NA_DISABLE_RULE,
                  // rules: [{ rule: [{ field: 'check_hearing_aid_used', value: 'Right Ear', operator: '===' }], action: 'CLEAR' }],
                },
                {
                  label: "Audiometric Test Results",
                  type: "Label",
                  col: "col-12 border-0 text-audio-heading fw-bold",
                },
                {
                  label: "",
                  type: "Label",
                  col: "col-4 bg-light text-vision-heading fw-bold",
                },
                {
                  label: "500 HZ",
                  type: "Label",
                  col: "col-2 bg-light text-vision-heading fw-bold",
                },
                {
                  label: "1000 HZ",
                  type: "Label",
                  col: "col-2 bg-light text-vision-heading fw-bold",
                },
                {
                  label: "2000 HZ",
                  type: "Label",
                  col: "col-2 bg-light text-vision-heading fw-bold",
                },
                {
                  label: "AVERAGE",
                  type: "Label",
                  col: "col-2 bg-light text-vision-heading fw-bold",
                },
                // Left Row
                {
                  label: "Left",
                  type: "Label",
                  col: "col-4 border-0 text-vision-heading fw-bold",
                },
               {
                    label:'500 Hz',
                    isLabel:false,
                    type:'Number',
                    col:'col-2 border-0 ',
                    rangeMax:40,
                    max:2,
                    name:'audiometric_test_results_left_ear_500_hz',
                    id:'audiometric_test_results_left_ear_500_hz',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                 },
                 {
                    label:'1000 Hz',
                    isLabel:false,
                    type:'Number',
                    rangeMax:40,
                    max:2,
                    col:'col-2 border-0 ',
                    name:'audiometric_test_results_left_ear_1000_hz',
                    id:'audiometric_test_results_left_ear_1000_hz',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                },
                {
                    label:'2000 Hz',
                    isLabel:false,
                    type:'Number',
                    rangeMax:40,
                    max:2,
                    col:'col-2 border-0 ',
                    name:'audiometric_test_results_left_ear_2000_hz',
                    id:'audiometric_test_results_left_ear_2000_hz',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                 },           
                {
                    label:'Average',
                    isLabel:false,
                    type:'Number',
                    readOnly:true,
                    col:'col-2 border-0 ',
                    name:'audiometric_test_results_left_ear_average',
                    id:'audiometric_test_results_left_ear_average',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                },
                // Right Row
                {
                  label: "Right",
                  type: "Label",
                  col: "col-4 border-0 text-vision-heading fw-bold",
                },
               {
                    label:'500 Hz',
                    isLabel:false,
                    type:'Number',
                    rangeMax:40,
                    max:2,
                    col:'col-2 border-0 ',
                    name:'audiometric_test_results_right_ear_500_hz',
                    id:'audiometric_test_results_right_ear_500_hz',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                },
                {
                    label:'1000 Hz',
                    isLabel:false,
                    type:'Number',
                    max:2,
                    col:'col-2 border-0 ',
                    rangeMax:40,
                    name:'audiometric_test_results_right_ear_1000_hz',
                    id:'audiometric_test_results_right_ear_1000_hz',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                },
                {
                    label:'2000 Hz',
                    isLabel:false,
                    type:'Number',
                    rangeMax:40,
                    max:2,
                    col:'col-2 border-0 ',
                    name:'audiometric_test_results_right_ear_2000_hz',
                    id:'audiometric_test_results_right_ear_2000_hz',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                },
                {
                    label:'Average',
                    isLabel:false,
                    type:'Number',
                    readOnly:true,
                    col:'col-2 border-0 ',
                    name:'audiometric_test_results_right_ear_average',
                    id:'audiometric_test_results_right_ear_average',
                    rules: HEARING_AID_NA_DISABLE_RULE,
                },
              ],
            },
          ],
        },
        {
          label: "Exam",
          id: "exam",
          labelStyle: "padding: 0;",
          data: [
            {
              label: "Activity Details - Health Information Review",
              labelStyle: "fw-semibold",
              headerRadio: {
                name: "health_information_review_radio",
                id: "health_information_review_radio",
                options: [
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ],
              },
              fields: [
                {
                  label:
                  type === "ProviderExam"
                      ? "Review and discuss patient answers and any medical records. Comment on responses."
                      : 'Review and discuss Employee/patient answers and any available medical records. Comment on the responses to the "health history".',
                  type: "Label",
                  col: "col-12 border-0 text-dark",
                },
                {
                  label: "",
                  type: "TextArea",
                  name: "health_information_review",
                  col: "col-12 border-0 ",
                  id: "health_information_review",
                  disabled: true,
                  rules: [
                    {
                      rule: [{field: "health_information_review_radio",value: "Yes",operator: "===",},],action: "ENABLE",
                    },
                  ],
                  isLabel: false,
                  placeholder: "Add Comments",
                },
              ],
            },
            {
              label: 'Normal/Abnormal',
              hideHeader: true, // Single header: "History" + Yes/No in NewYesOrNoFields header only
              cardBodyClassName: 'p-0',
              fields: [
                {
                  col: "col-12 border-0",
                  isLabel: false,
                  defaultBtnLabel: "Set all to Normal",
                  type: "NewYesOrNoFields",
                  label: "Normal/Abnormal",
                  options: [
                    { label: "Abnormal", value: "Abnormal" },
                    { label: "Normal", value: "Normal" },
                  ],
                  defaultValues: physicalExamination.reduce((acc, itm) => {
                    acc[itm.name] = "Normal";
                    return acc;
                  }, {}),
                  failedValue: ["Abnormal"],
                  list: physicalExamination,
                },
                { 
                    label: "Comments", 
                    type: "Label", 
                    col: "col-12 border-0 text-dark" },
                {
                  label: "",
                  type: "TextArea",
                  col: "col-12 border-0",
                  name: "physical_examination_comments",
                  id: "physical_examination_comments",
                  placeholder: "Add Comments",
                  isLabel: false,
                },
              ],
            },
          ],
        },
      {
                          label: 'Certification',
                          id: 'certification',
                          data: [
                             ...(type === "ProviderExam" ? [{
                                  label: 'Type of Certification',
                                  labelStyle: "fw-semibold",
                                  headerRadio: {
                                      name: 'medical_examiner_determination',
                                      id: 'medical_examiner_determination',
                                      options: [{ label: 'Federal', value: 'Federal' }, { label: 'State', value: 'State' }],
                                      // defaultValue: 'Federal'
                                  },
                                  fields: [
                                      {
                                          type: 'CertificationForm',
                                          col: 'col-12',
                                          fields: [
                                      {
                                          label: 'Does Not Meet Standards (Specify Reason):',
                                          type: 'RadioGroup',
                                          name: 'certification_status',
                                          col: 'col-12',
                                          id: 'certification_status_does_not_meet',
                                          options: [{ label: 'Does Not Meet Standards (Specify Reason):', value: 'does_not_meet_standards' }],
                                      },
                                      {
                                          label: '',
                                          type: 'TextInput',
                                          col: 'col-12',
                                          name: 'does_not_meet_standards_reason',
                                          id: 'does_not_meet_standards_reason',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: "Add Reason",
                                          rules: [{ rule: [{ field: 'certification_status', value: 'does_not_meet_standards', operator: '===' }], action: 'ENABLE' },{ rule: [{ field: 'certification_status', value: 'does_not_meet_standards', operator: '==' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for does not meet standards.' }],
                                      },
                                      {
                                          label: 'Meets Standards In 49 CFR 391.41; Qualifies For 2-Year Certificate',
                                          type: 'RadioGroup',
                                          name: 'certification_status',
                                          col: 'col-12',
                                          id: 'certification_status_meets_2_year',
                                          options: [{ label: 'Meets Standards In 49 CFR 391.41; Qualifies For 2-Year Certificate', value: 'meets_standards_2_year' }],
                                      },
                                      {
                                          label: 'Meets Standards, But Periodic Monitoring Required (Specify Reason):',
                                          type: 'RadioGroup',
                                          name: 'certification_status',
                                          col: 'col-12',
                                          id: 'certification_status_monitoring',
                                          options: [{ label: 'Meets Standards, But Periodic Monitoring Required (Specify Reason)' , value: 'meets_standards_monitoring' }],
                                      },
                                      {
                                          label: '',
                                          type: 'TextInput',
                                          col: 'col-12',
                                          name: 'meets_standards_monitoring_reason',
                                          id: 'meets_standards_monitoring_reason',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: "Add Reason",
                                          rules: [
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '===' }], action: 'ENABLE' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '==' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for meets standards, but periodic monitoring required.' }
                                          ],
                                      },
                                      {
                                          label: 'Monitoring Duration:',
                                          type: 'RadioGroup',
                                          name: 'driver_qualified',
                                          col: 'col-12',
                                          id: 'driver_qualified',
                                          options: [
                                              { label: '3 months', value: '3 months' },
                                              { label: '6 months', value: '6 months' },
                                              { label: '1 year', value: '1 year' },
                                              { label: 'Other (specify in days):', value: 'Other' }
                                          ],
                                          disabled: true,
                                          rules: [
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '===' }], action: 'ENABLE' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' }
                                          ],
                                      },
                                      {
                                          label: '',
                                          type: 'Number',
                                          col: 'col-12 border-0',
                                          name: 'driver_qualified_other_reason',
                                          id: 'driver_qualified_other_reason',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: 'Content',
                                          rules: [
                                              { rule: [{ field: 'driver_qualified', value: 'Other', operator: '===' }], action: 'ENABLE' },
                                              { rule: [{ field: 'driver_qualified', value: 'Other', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'driver_qualified', value: 'Other', operator: '==' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for other.' }
                                          ],
                                      },
                                      {
                                          label: 'Wearing Corrective Lenses',
                                          type: 'Checkbox',
                                          name: 'wearing_corrective_lenses_certification',
                                          col: 'col-12',
                                          id: 'wearing_corrective_lenses_certification',
                                          disabled: true,
                                          rules: [
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '===' }], action: 'ENABLE' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'DISABLE' }
                                          ],
                                      },
                                      {
                                          label: 'Wearing Hearing Aid',
                                          type: 'Checkbox',
                                          name: 'wearing_hearing_aid',
                                          col: 'col-12',
                                          id: 'wearing_hearing_aid',
                                          disabled: true,
                                          rules: [
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '===' }], action: 'ENABLE' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'DISABLE' }
                                          ],
                                      },
                                      {
                                          label: 'Accompanied By A Waiver/Exemption (Specify Type)',
                                          type: 'Checkbox',
                                          name: 'accompanied_by_waiver_exemption',
                                          col: 'col-12',
                                          id: 'accompanied_by_waiver_exemption',
                                          disabled: true,
                                          labelWrap:false,
                                          rules: [
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '===' }], action: 'ENABLE' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'DISABLE' }
                                          ],
                                      },
                                      {
                                          label: '',
                                          type: 'TextInput',
                                          col: 'col-12',
                                          name: 'type',
                                          id: 'type',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: 'Content',
                                          rules: [
                                              { rule: [{ field: 'accompanied_by_waiver_exemption', value: 1, operator: '===' }], action: 'ENABLE' },
                                              { rule: [{ field: 'accompanied_by_waiver_exemption', value: 1, operator: '===' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for accompanied by a waiver/exemption.' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'DISABLE' }
                                          ],
                                      },
                                      {
                                          label: 'Accompanied By A Skill Performance Evaluation (SPE) Certificate',
                                          type: 'Checkbox',
                                          labelWrap:false,
                                          name: 'accompanied_by_spe_certificate',
                                          col: 'col-12',
                                          id: 'accompanied_by_spe_certificate',
                                          rules: [
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'DISABLE' }
                                          ],
                                      },
                                      {
                                          label: 'Driving Within An Exempt Intracity Zone (See 49 CFR 391.62) (Federal) Q',
                                          type: 'Checkbox',
                                          name: 'driving_within_an_exempt_intracity_zone',
                                          col: 'col-12',
                                          labelWrap:false,
                                          id: 'driving_within_an_exempt_intracity_zone',
                                          rules: [
                                              { rule: [{ field: 'medical_examiner_determination', value: 'Federal', operator: '===' }], action: 'SHOW' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'DISABLE' }
                                          ],
                                      },
                                       {
                                          label: 'Grandfathered from State requirements (State)',
                                          type: 'Checkbox',
                                          name: 'is_grandfathered_state_requirements',
                                          col: 'col-12',
                                          labelWrap:false,
                                          id: 'is_grandfathered_state_requirements',
                                              rules: [
                                              { rule: [{ field: 'medical_examiner_determination', value: 'State', operator: '===' }], action: 'SHOW' },
                                              { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'CLEAR' },
                                              // { rule: [{ field: 'certification_status', value: 'meets_standards_monitoring', operator: '!==' }], action: 'DISABLE' }
                                          ],
                                      },
                                      {
                                          label: 'Determination Pending (Specify Reason)',
                                          type: 'RadioGroup',
                                          name: 'certification_status',
                                          col: 'col-12',
                                          id: 'certification_status_pending',
                                          options: [{ label: 'Determination Pending (Specify Reason)', value: 'determination_pending' }],
                                      },
                                      {
                                          label: '',
                                          type: 'TextInput',
                                          col: 'col-12',
                                          name: 'determination_pending_reason',
                                          id: 'determination_pending_reason',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: 'Content',
                                          rules: [{ rule: [{ field: 'certification_status', value: 'determination_pending', operator: '===' }], action: 'ENABLE' },{ rule: [{ field: 'certification_status', value: 'determination_pending', operator: '==' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for determination pending.' }],
                                      },
                                      {
                                          label: 'Return To Medical Exam Office For Follow-Up On (Must Be 45 Days Or Less):',
                                          type: 'Checkbox',
                                          labelWrap:false,
                                          name: 'return_to_medical_exam_office_for_follow_up',
                                          col: 'col-12',
                                          id: 'return_to_medical_exam_office_for_follow_up',
                                      },
                                      {
                                          label: '',
                                          type: 'Date',
                                          col: 'col-12 border-0',
                                          name: 'follow_up_date',
                                          id: 'follow_up_date',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: 'Content',
                                          rules: [{ rule: [{ field: 'return_to_medical_exam_office_for_follow_up', value: 1, operator: '===' }], action: 'ENABLE' },{ rule: [{ field: 'return_to_medical_exam_office_for_follow_up', value: 1, operator: '==' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for return to medical exam office for follow-up.' }],
                                      },
                                      {
                                          label: 'Medical Examination Report Amended (Specify Reason)',
                                          type: 'Checkbox',
                                          labelWrap:false,
                                          name: 'medical_examination_report_amended',
                                          col: 'col-12',
                                          id: 'medical_examination_report_amended',
                                      },
                                      {
                                          label: '',
                                          type: 'TextInput',
                                          col: 'col-12',
                                          name: 'medical_examination_report_amended_reason',
                                          id: 'medical_examination_report_amended_reason',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: 'Content',
                                          rules: [{ rule: [{ field: 'medical_examination_report_amended', value: 1, operator: '===' }], action: 'ENABLE' },{ rule: [{ field: 'medical_examination_report_amended', value: 1, operator: '==' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for medical examination report amended.' }],
                                      },
                                      {
                                          label: 'Incomplete Examination (Specify Reason)',
                                          type: 'RadioGroup',
                                          name: 'certification_status',
                                          col: 'col-12',
                                          id: 'incomplete_examination',
                                          options: [{ label: 'Incomplete Examination (Specify Reason)', value: 'incomplete_examination' }],
                                      },
                                      {
                                          label: '',
                                          type: 'TextInput',
                                          col: 'col-12',
                                          name: 'incomplete_examination_reason',
                                          id: 'incomplete_examination_reason',
                                          disabled: true,
                                          isLabel: false,
                                          placeholder: 'Content',
                                          rules: [{ rule: [{ field: 'certification_status', value: 'incomplete_examination', operator: '===' }], action: 'ENABLE' },{ rule: [{ field: 'certification_status', value: 'incomplete_examination', operator: '==' }], action: 'REQUIRED', errorMessage: 'Please provide a reason for incomplete examination.' }],
                                      },
                                          ]
                                      },
                                  ]
                              }] : [{
                  
                                       label: 'Medical Examiner Determination and Status', 
                                       labelStyle: "fw-semibold",
                                       fields: [
                                                 {
                                                    label: 'Medical Record',
                                                    type: 'TextInput',
                                                    name: 'medical_record',
                                                    id: 'medical_record',
                                                    col:"col-6 border-0"
                                                },
              {
                  label: 'Exam Date',
                  type: 'Date',
                  name: 'exam_date',
                  id: 'exam_date',
                  col:"col-6 border-0"
              },
              {
                  label: 'Employment Status',
                  type: 'MultiSelectDropDown',
                  ddKey: 'employmentstatus',
                  isToogle: true,
                  rules: (type === 'ProviderExam') ? [{ rule: [{ field: 'medical_examiner_determination', value: "", operator: '!==' }], action: 'SHOW' }] : [],
                  options: props.employmenStatusOption,
                  id: 'employment_status',
                  name: 'employment_status',
                  col:"col-6 border-0"
              },
              {
                  label: 'Provider',
                  type: 'SelectSearchList',
                  isAsync: true,
                  options: [],
                  autoPopulateFields: {
                      medical_examiners_certificate_expiration_date: 'unavailable_until',
                  },
                  loadCallBack: (val, callback) => fetchProviderList(val, props, callback),
                  name: 'provider',
                  id: 'provider',
                  col:"col-6 border-0",
                  rules: (type === 'ProviderExam') ? [{ rule: [{ field: 'medical_examiner_determination', value: "", operator: '!==' }], action: 'SHOW' }] : [],
              },
              {
                  label: 'Notes',
                  col: 'col-6 border-0',
                  type: 'TextArea',
                  rules: (type === 'ProviderExam') ? [{ rule: [{ field: 'medical_examiner_determination', value: "", operator: '!==' }], action: 'SHOW' }] : [],
                  name: 'notes',
      
              },
                      
                  ]
              }]),
                              {
                                  label: type === 'ProviderExam' ? 'Provider Signature & Date' : 'Review / Completion',
                                  labelStyle: "fw-semibold",
                                  col: 'col-12',
                                  fields: [
                                      ...(type === 'ProviderExam' ? [
                                          {
                                              label:"Date Certificate Signed",
                                              type:'NewDate',
                                              isLabel:false,
                                              col: 'col-md-6 col-12 border-0',
                                              name:'date_certificate_signed',
                                              id:'date_certificate_signed',
                                          },
                                          {
                                              label: 'Exam Date',
                                              type: 'NewDate',
                                              isLabel: false,
                                              col: 'col-md-6 col-12 border-0',
                                              name: 'exam_date',
                                              id: 'exam_date',
                                          },
                                          {
                                              label:"Medical Examiner's Signature",
                                              isLabel: false,
                                              type: 'NewSignature',
                                              col: 'col-md-6 col-12 border-0',
                                              name:'medical_examiner_signature_two',
                                              id:'medical_examiner_signature_two'
                                          },
                                          {
                                               label:'',
                                               type:'Blank',
                                              isLabel: false,
                                              col: 'col-md-2 border-0',
                                              
                                          },
                                          {
                                              label:"Medical Examiner's Name",
                                              type:'SelectSearchList',
                                              isAutoPopulate:true,
                                              placeholder:'Medical Examiner',
                                              isAsync:true,
                                              options:[],
                                              loadCallBack:(val,callback)=>fetchProviderList(val,props,callback),
                                              name:'medical_examiner_name',
                                              id:'medical_examiner_name',
                                              col:'col-md-6 border-0 col-12',
                                              required:true
                                          },
                                          {
                                      label:"Medical Examiner's Address",
                                      type:'Address',
                                      name:'medical_examiner_address',
                                      id:'medical_examiner_address',
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:"City",
                                      type:'TextInput',
                                      name:'city',
                                      id:'city',
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:"State",
                                      type:'SelectList',
                                      name:'state',
                                      id:'state',
                                      options: stateOptions,
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:"Zip code",
                                      type:'TextInput',
                                      name:'zip_code',
                                      id:'zip_code',
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:"Medical Examiner's Telephone Number",
                                      type:'Phone',
                                      name:'medical_examiner_telephone_number',
                                      id:'medical_examiner_telephone_number',
                                      labelWrap:false,
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:"Issuing State",
                                      type:'SelectList',
                                      name:'issuing_state',
                                      id:'issuing_state',
                                      options: stateOptions,
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:"Medical Examiner's State License, Certificate, or Registration Number",
                                      type:'TextInput',
                                      labelWrap:false,
                                      name:'medical_examiners_license_certificate_or_registration_number',
                                      id:'medical_examiners_license_certificate_or_registration_number',
                                       col: 'col-6 border-0',
                                  },
                                 
                                  {
                                      label:"National Registry Number",
                                      type:'TextInput',
                                      name:'national_registry_number',
                                      id:'national_registry_number',
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:'Type of Medical Practitioner',
                                      type:'MultiSelectDropDown',
                                      isToogle:true,
                                      ddKey:'medicalPractitioner',
                                      options:optionsToKeyValuePairs(["Advanced Practice Nurse","Chiropractor","DO","MD","Other Practitioner","Physician Assistant"]),
                                      name:'type_of_medical_practitioner',
                                      id:'type_of_medical_practitioner',
                                       col: 'col-6 border-0',
                                  },
                                  {
                                      label:'',
                                      isLabel:false,
                                      placeholder: 'Please specify other practitioner type...',
                                      type:'TextArea',
                                      name:'specify',
                                      id:'specify',
                                      col: 'col-6 border-0',
                                      // 1. Set default state to disabled
                                      disabled: true, 
                                      rules: [{ rule: [{field: 'type_of_medical_practitioner',value: 'Other Practitioner',operator: 'includes',}],action: 'ENABLE'},]},
                                  
                                          {
                                              label:"Medical Examiner's Certificate Expiration Date",
                                              type:'NewDate',
                                              isLabel:false,
                                              col:'col-md-6 col-12 border-0',
                                              name:'medical_examiners_certificate_expiration_date',
                                              id:'medical_examiners_certificate_expiration_date',
                                              disabled:true,
                                          },
                                      {
                                          label: 'Status',
                                          type: 'SelectList',
                                          col: 'col-6 border-0',
                                          options: isSet(props.lookupsOptions && props.lookupsOptions['chartResult'], []),
                                          name: 'status',
                                          id: 'status',
                                      },
                                      {
                                          label: 'Status',
                                          type: 'SelectList',
                                          col: 'col-6 border-0',
                                          options: isSet(props.lookupsOptions && props.lookupsOptions['chartResult'], []),
                                          name: 'status',
                                          id: 'status',
                                      },
                                      ] : [
                                          {
                                              type: 'ProviderSignOff',
                                              col: 'col-12',
                                              fields: [
                                                  {
                                                      label: 'Signature PIN',
                                                      name: 'provider_pin',
                                                      col: 'col-12',
                                                  },
                                                  {
                                                      label: 'Signature',
                                                      type: 'NewSignature',
                                                      name: 'provider_signature',
                                                      col: 'col-12',
                                                  },
                                                  {
                                                      label: 'Date',
                                                      type: 'Date',
                                                      name: 'signed_date',
                                                      col: 'col-12',
                                                  },
                                                  // {
                                                  //     label: "Suggested Result",
                                                  //     disabled:true,
                                                  //     placeholder: 'Not Started',
                                                  //     type: "TextInput",
                                                  //     name: "suggested_status",
                                                  //     col: "col-6"
                                                  // },
                                                  // Existing options (commented for reference):
                                                  // {
                                                  //     label: "Final Results",
                                                  //     type: "SelectList",
                                                  //     name: "status",
                                                  //     col: "col-6",
                                                  //     options: optionsToKeyValuePairs(['Not Started','Pending','Normal', 'Abnormal', 'Positive', 'Negative', 'Passed', 'Failed'])
                                                  // },
                                                  // {
                                                  //     label: "Activity Status",
                                                  //     type: "SelectList",
                                                  //     name: "activity_status",
                                                  //     col: "col-12",
                                                  //     options: optionsToKeyValuePairs(['Not Started', 'Ordered', 'Completed', 'Cancelled'])
                                                  // },
                                                  {
                                                      label: "Final Results",
                                                      type: "SelectList",
                                                      name: "status",
                                                      col: "col-12",
                                                      options: optionsToKeyValuePairs(
                                                          [
                                                              "Not Started",
                                                              "Pending",
                                                              "Normal",
                                                              "Abnormal",
                                                              "Negative",
                                                              "Positive",
                                                              "Dispensed",
                                                              "Administered",
                                                              "Failed",
                                                              "Passed",
                                                              "Non-Negative",
                                                              "Cancelled",
                                                              "Inconclusive",
                                                          ],
                                                          false
                                                      ),
                                                      statusBasedColor: true,
                                                  },
                                                  {
                                                      label: "Activity Status",
                                                      type: "SelectList",
                                                      name: "activity_status",
                                                      col: "col-12",
                                                      options: optionsToKeyValuePairs(
                                                          [
                                                              "Not Started",
                                                              "Pending",
                                                              "Pending Lab Confirmation",
                                                              "Pending MRO Confirmation",
                                                              "Ready for Review",
                                                              "Completed",
                                                              "Cancelled",
                                                          ],
                                                          false
                                                      ),
                                                      statusBasedColor: true,
                                                  },
                                              ],
                                          },
                                      ]),
                                  ]
                              },
                          ]
                      },
                      {
                              label: 'Recap',
                              id: 'recap',
                              data: [
                                       {
                                           label: 'Do you have or have you ever had',
                                           labelStyle: "fw-semibold",
                                           fields: [
                                                     {
                                                        col: 'col-12',
                                                        type: 'YesAnswersDisplay',
                                                        label: 'Do you have or have you ever had',
                                                        list: patientHealthInformation,
                                                     },
                                                   ]
                                        },
                                    ]
                      },
        {
          id: "Images",
          label: "Images",
          data: [],
        },
        // {
        //   label: "Recap",
        //   id: "recap",
        //   data: [
        //     {
        //       // label: 'Do you have or have you ever had',
        //       labelStyle: "fw-semibold",
        //       fields: [
        //         {
        //           col: "col-12",
        //           type: "YesAnswersDisplay",
        //           label: "Do you have or have you ever had",
        //           list: patientHealthInformation,
        //         },
        //       ],
        //     },
        //     {
        //       label: "Certificate Details",
        //       labelStyle: "fw-semibold",
        //       fields: [
        //         {
        //           label: "Certificate Issued",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "certificate_issued",
        //         },
        //         {
        //           label: "Certificate Type",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "certificate_type_display",
        //         },
        //         {
        //           label: "Status",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "certificate_status_display",
        //         },
        //       ],
        //     },
        //     {
        //       label: "Transaction Timeline",
        //       labelStyle: "fw-semibold",
        //       fields: [
        //         {
        //           label: "History Completed (Patient)",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "history_completed_patient",
        //         },
        //         {
        //           label: "Doctor Signed Off",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "doctor_signed_off",
        //         },
        //         {
        //           label: "Results Sent to Employer",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "results_sent_to_employer",
        //         },
        //         {
        //           label: "Results Sent to Employee",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "results_sent_to_employee",
        //         },
        //         {
        //           label: "Results Sent to Department of Transportation",
        //           type: "Label",
        //           col: "col-12",
        //           displayValue: true,
        //           displayName: "results_sent_to_dot",
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
    },
  ];

  const headers = [];

  const defaultValue = {
    status: "Not Started",
    suggested_status: "Not Started",
    activity_status: "Not Started",
    pulse_rate_result: "Not Started",
    blood_pressure_result: "Not Started",
    vission_result: "Not Started",
    urinalysis_result: "Not Started",
    medical_examiner_determination: "Federal",
  };
  const buttons = {
    PDF: true,
  };
 
  return {
    charts,
    defaultValue,
    buttons,
    headers,
    computationFunction: async (formData, key) => ({
      ...(await computationRules(formData, key, patientHealthInformation, props)),
      // ...computationRules1(formData, key),
    }),
  };
};

const computationRules = async (formData,key,healthInfoList = [],props = {}) => {
  const pulse = isSet(formData.pulse_rate, "");
  const systolic = isSet(formData.sitting_systolic, "");
  const diastolic = isSet(formData.sitting_diastolic, "");
  let returnResult = {};

  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");

  // If user changes any field while both status and activity_status are "Not Started",
  // move to Pending Result / In Progress
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (medical_examiner_signature_two exists and is not empty)
    const providerSigned = formData.provider_signature&& 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }

  if(key === 'provider_signature' && formData.status) {
    const status = formData.status;
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
    
    if (completionStatuses.includes(status)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    }
  }

  // Auto-fill clinic details ONLY when medical_examiner_name is being changed
  // This prevents overwriting user edits to other fields
  if (key === "medical_examiner_name") {
    const medicalExaminerName = isSet(formData.medical_examiner_name, "");
    if (medicalExaminerName) {
      // Fetch clinic data directly from database in real-time
      console.log("employeeDetails", props.employeeDetails);
      const clinicId = props.employeeDetails?.clinic_id;
      console.log("clinicId", clinicId);
      if (clinicId) {
        try {
          console.log("clinicId inside if", clinicId);
          // const orgId = getOrganizationId();
          const clinic = await ClinicService.getClinic(clinicId);

          if (clinic) {
            // Only auto-fill if fields are currently empty (don't overwrite existing values)
            if (
              clinic.address &&
              (!formData.medical_examiner_address ||
                formData.medical_examiner_address === "")
            ) {
              returnResult.medical_examiner_address = isSet(clinic.address, "");
            }
            if (clinic.city && (!formData.city || formData.city === "")) {
              returnResult.city = isSet(clinic.city, "");
            }
            if (clinic.state && (!formData.state || formData.state === "")) {
              returnResult.state = isSet(clinic.state, "");
            }
            if (
              clinic.zip_plus_4 &&
              (!formData.zip_code || formData.zip_code === "")
            ) {
              returnResult.zip_code = isSet(clinic.zip_plus_4, "");
            }
            if (
              clinic.phone &&
              (!formData.medical_examiner_telephone_number ||
                formData.medical_examiner_telephone_number === "")
            ) {
              returnResult.medical_examiner_telephone_number = isSet(
                clinic.phone,
                ""
              );
            }
            if (
              clinic.state &&
              (!formData.issuing_state || formData.issuing_state === "")
            ) {
              returnResult.issuing_state = isSet(clinic.state, "");
            }
          }
        } catch (error) {
          console.error("Error fetching clinic data:", error);
        }
      }
    }
  }

  if (key === "check_hearing_aid_used") {
    const side = isSet(formData.check_hearing_aid_used, "");
    if (side === "N/A") {
      returnResult.wearing_hearing_aid = 0;
      ["left_ear_", "right_ear_"].forEach((prefix) => {
        [500, 1000, 2000, 3000, 4000, 6000, 8000].forEach((fq) => {
          returnResult[`audiometric_test_results_${prefix}${fq}_hz`] = "";
        });
      });
      returnResult.whisper_test_results_right_ear = "";
      returnResult.whisper_test_results_left_ear = "";
      returnResult.audiometric_test_results_left_ear_average = "";
      returnResult.audiometric_test_results_right_ear_average = "";
    } else {
      const usesAid = side === "Right Ear" || side === "Left Ear";
      returnResult.wearing_hearing_aid = usesAid;
    }
  }

  const triggerFields = [
    "exam_date",
    "certification_status",
    "driver_qualified",
    "driver_qualified_other_reason",
    "medical_examiner_name",
  ];
  if (triggerFields.includes(key) && formData.exam_date) {
    const examDate = new Date(formData.exam_date);

    if (!isNaN(examDate.getTime())) {
      let expirationDate = new Date(examDate);
      const certStatus = formData.certification_status;
      const monitoringDuration = formData.driver_qualified;
      const otherDays = formData.driver_qualified_other_reason;

      // A. If 2-Year Certificate is selected
      if (certStatus === "meets_standards_2_year") {
        expirationDate.setFullYear(expirationDate.getFullYear() + 2);
        returnResult["medical_examiners_certificate_expiration_date"] =
          formatDate(expirationDate);
      }

      // B. If Periodic Monitoring is selected
      else if (certStatus === "meets_standards_monitoring") {
        if (monitoringDuration === "3 months") {
          expirationDate.setMonth(expirationDate.getMonth() + 3);
        } else if (monitoringDuration === "6 months") {
          expirationDate.setMonth(expirationDate.getMonth() + 6);
        } else if (monitoringDuration === "1 year") {
          expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        } else if (
          monitoringDuration === "Other" &&
          isSet(otherDays, "") !== ""
        ) {
          // Logic for custom days
          expirationDate.setDate(
            expirationDate.getDate() + parseInt(otherDays)
          );
        }

        returnResult["medical_examiners_certificate_expiration_date"] =
          formatDate(expirationDate);
      }
    }
  }
  if (healthInfoList.length > 0) {
    // Get all question keys from questions 1-31 (healthInfoList) and question 32 (other_conditions)
    const questionKeys = [
      ...healthInfoList.map((item) => item.name),
      "other_conditions",
    ];

    // Check if any question from 1-32 is "Yes"
    const hasAnyYesAnswer = questionKeys.some(
      (qKey) => formData[qKey] === "Yes"
    );

    // Check if all questions from 1-32 are "No"
    const allNoAnswers = questionKeys.every((qKey) => formData[qKey] === "No");

    // If any question is "Yes", set question 33 (additional_comments) to "Yes"
    if (hasAnyYesAnswer) {
      returnResult["additional_comments"] = "Yes";
    }
    // If all questions are "No", set question 33 (additional_comments) to "No"
    if (allNoAnswers) {
      returnResult["additional_comments"] = "No";
    }
  }
  let pulseRateResult = "Not Started";
  if (pulse == "") {
    pulseRateResult = "Not Started";
  } else if (pulse >= 60 && pulse <= 100) {
    pulseRateResult = "Normal";
  } else if (pulse !== "") {
    pulseRateResult = "Abnormal";
  }

  let bloodPressureResult = "Not Started";
  if (systolic === "" && diastolic === "") {
    bloodPressureResult = "Not Started";
  } else if (systolic === "" || diastolic === "") {
    bloodPressureResult = "Pending";
  } else if (
    systolic < 0 ||
    systolic > 139 ||
    diastolic < 0 ||
    diastolic > 89
  ) {
    bloodPressureResult = "Abnormal";
  } else {
    bloodPressureResult = "Normal";
  }

  const spgr = isSet(formData.sp_gr, "");
  const protein = isSet(formData.protein, "");
  const blood = isSet(formData.blood, "");
  const sugar = isSet(formData.sugar, "");

  let urinariesResult = "Not Started";

  const sgNormalRange = { min: 1.002, max: 1.03 };
  const sgWithinNormalRange =
    spgr >= sgNormalRange.min && spgr <= sgNormalRange.max;

  // Check Protein, Blood, and Sugar levels
  const abnormalLevels = protein > 0 || blood > 0 || sugar > 0;

  // Determine status
  if (spgr === "" || protein === "" || blood === "" || sugar === "") {
    urinariesResult = "Pending";
  } else if (sgWithinNormalRange && !abnormalLevels) {
    urinariesResult = "Normal";
  } else if (!sgWithinNormalRange || abnormalLevels) {
    urinariesResult = "Abnormal";
  } else {
    urinariesResult = "Pending";
  }
  let visionResult = "Not Started";
  const wearing_corrective_lenses = isSet(
    formData["wearing_corrective_lenses"],
    null
  );
  const conditions =
    wearing_corrective_lenses === 0 ? "uncorrected" : "corrected";
  const horizontalRighteye = isSet(
    formData["horizontal_field_of_vision_right_eye"],
    ""
  );
  const horizontalLeftEye = isSet(
    formData["horizontal_field_of_vision_left_eye"],
    ""
  );
  const applicantRecoginize = isSet(
    formData["applicant_recognize_traffic_control_signals"],
    ""
  );
  const monocularvision = isSet(formData["monocular_vision"], "");

  if (wearing_corrective_lenses !== null) {
    const rightEye = isSet(formData["" + conditions + "_right_eye"], "");
    const bothEyes = isSet(formData["" + conditions + "_both_eyes"], "");
    const leftEye = isSet(formData["" + conditions + "_left_eye"], "");

    if (
      rightEye === "" ||
      bothEyes === "" ||
      leftEye === "" ||
      horizontalRighteye === "" ||
      horizontalLeftEye === ""
    ) {
      visionResult = "Pending";
    } else if (
      rightEye > 40 ||
      bothEyes > 40 ||
      leftEye > 40 ||
      horizontalRighteye < 70 ||
      horizontalRighteye > 90 ||
      horizontalLeftEye < 70 ||
      horizontalLeftEye > 90
    ) {
      visionResult = "Failed";
    } else {
      visionResult = "Passed";
    }
  } else {
    if (horizontalRighteye === "" || horizontalLeftEye === "") {
      visionResult = "Pending";
    } else if (
      horizontalRighteye < 70 ||
      horizontalRighteye > 90 ||
      horizontalLeftEye < 70 ||
      horizontalLeftEye > 90 ||
      applicantRecoginize === "No" ||
      monocularvision === "No"
    ) {
      visionResult = "Failed";
    } else {
      visionResult = "Passed";
    }
  }

  const earPrefixes = ["right_ear_", "left_ear_"];
  earPrefixes.forEach((earPrefix) => {
    const frequencies = [500, 1000, 2000, 3000, 4000, 6000, 8000];
    let total = 0;

    frequencies.forEach((frequency) => {
      const value = isSet(
        formData[`audiometric_test_results_${earPrefix}${frequency}_hz`],
        ""
      );
      total += Number(value);
    });
    const average = Math.ceil(total / frequencies.length);
    returnResult[`audiometric_test_results_${earPrefix}average`] = average;
  });

  const leftAverage =
    returnResult[`audiometric_test_results_left_ear_average`];
  const rightAverage =
    returnResult[`audiometric_test_results_right_ear_average`];
  const whisperTestRightEar = isSet(
    formData[`whisper_test_results_right_ear`],
    ""
  );
  const whisperTestLeftEar = isSet(
    formData[`whisper_test_results_left_ear`],
    ""
  );
   const hearingAidChoice = isSet(formData.check_hearing_aid_used, "");

  let hearingResult = "Not Started";
  if (hearingAidChoice === "N/A") {
    hearingResult = "N/A";
  } else if (
    Number(leftAverage) === 0 &&
    Number(rightAverage) === 0 &&
    whisperTestRightEar == "" &&
    whisperTestLeftEar === ""
  ) {
    hearingResult = "Not Started";
  } else if (
    (leftAverage !== "0.00" && leftAverage <= 40 && leftAverage !== 0) ||
    (rightAverage !== "0.00" && rightAverage <= 40 && rightAverage !== 0) ||
    whisperTestRightEar >= 5 ||
    whisperTestLeftEar >= 5
  ) {
    // console.log('ssss',leftAverage,rightAverage,whisperTestRightEar,whisperTestLeftEar);
    hearingResult = "Passed";
  } else if (
    (leftAverage === 0 || rightAverage === 0) &&
    (leftAverage > 40 || rightAverage > 40)
  ) {
    hearingResult = "Failed";
  } else if (
    leftAverage > 40 ||
    rightAverage > 40 ||
    (whisperTestRightEar < 5 && whisperTestLeftEar < 5)
  ) {
    hearingResult = "Failed";
  } else {
    hearingResult = "Pending";
  }
  returnResult = {
    ...returnResult,
    pulse_rate_result: pulseRateResult,
    blood_pressure_result: bloodPressureResult,
    vission_result: visionResult,
    hearing_result: hearingResult,
    urinalysis_result: urinariesResult,
  };
  return returnResult;
};
export const fetchProviderList = async (val,props, callback=()=>{}) => {
    const {employeeDetails} = props;
    let optionArr = [];
    try{
        const data = await ProviderService.getProviderByClinicId(employeeDetails.clinic_id,{search:val});
        isSet(data,[]).map((item,itemIndex)=>{
            optionArr.push({
                label:isSet(item.first_name,'')+' '+isSet(item.last_name,''),
                value:item.provider_id,
                autoPopulateFields:{
                    medical_examiners_certificate_expiration_date: "",
                    medical_examiners_license_certificate_or_registration_number:item.license,
                    national_registry_number:item.dol_registry_id,
                    medical_examiners_certificate_expiration_date:item.dol_registry_expires,
                },
                data:item,
                index:itemIndex
            })
        });
        callback(optionArr);
    }catch(e){

    }
    return optionArr;
  }
